import React from 'react';
import { StripeProvider } from './contexts/StripeContext';
import { AIModelPreferenceProvider } from './contexts/AIModelPreferenceContext';
import Routes from './Routes';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <StripeProvider>
        <AIModelPreferenceProvider>
          <Routes />
        </AIModelPreferenceProvider>
      </StripeProvider>
    </ErrorBoundary>
  );
}

export default App;